import React, { useState } from 'react'
import Creatable from "react-select/creatable"
import pluralize from "pluralize"

import { usePet, useToggle } from '../../modules'

import Modal from "../resusable/modal"

const EditInventoryItem = ({ toggle, item: itm, visible, onPerform = () => null }) => {
    const [units, setUnits] = useState([])
    const [categories, setCategories] = useState([])
    const [sCategories, setSCategories] = useState([])    

    const [name, setName] = useState(itm?.name)
    const [code, setCode] = useState(itm?.code)
    const [category, setCategory] = useState({ label: itm?.category, value: itm?.category })
    const [receivedIn, setReceivedIn] = useState({ label: itm?.receivedIn, value: itm?.receivedIn })
    const [issuedIn, setIssuedIn] = useState({ label: itm?.issuedIn, value: itm?.issuedIn })
    const [sp, setSp] = useState(null)
    const [sCategory, setSCategory] = useState(null)
    const [saleItem, setSaleItem] = useState(null)

    usePet('saleItemCategories', null, { notify: true, callback: ({ data }) => setSCategories(data) })
    usePet('inventoryCategories', null, { notify: true, callback: ({ data }) => setCategories(data) })
    usePet('inventoryUnits', null, { notify: true, callback: ({ data }) => setUnits(data) })
    usePet('saleItemByInvItem', { id: itm._id }, { notify: true, callback: ({ data }) => {
        setSaleItem(data)
        setSCategory({ label: data?.category, value: data?.category })
        setSp(data.price) 
    }})

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Item has been added to inventory', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, editInventoryItem] = usePet('editInventoryItem', {
        id: itm._id,
        name,
        category: category?.label,
        receivedIn: receivedIn?.label,
        issuedIn: issuedIn?.label,
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Saving changes...' } })

    const [{ loading: spLoading }, editSaleItem] = usePet('editSaleItem', {
        id: saleItem?._id,
        sp,
        category: category?.label,
    }, { notify: true, callback: () => null, manual: true })

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break
                
            case 'sp':
                setSp(e.target.value)
                break

            default:
                break
        }
    }

    return (
        <Modal
            h="h-auto"
            w="w-3/4 md:w-2/3 lg:w-1/3 2xl:w-1/4"
            title="Edit Inventory Item"
            toggle={toggle}
            visible={visible}>
            <div className="divide-y divide-light-gray-400">
                <div className="w-full pt-4">
                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full md:w-3/5 px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Name
                            </label>
                            <input
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-name"
                                type="text"
                                name="name"
                                value={ name }
                                onChange={ modify }
                                placeholder="Potatoes" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Category
                            </label>
                            <Creatable
                                value={category}
                                onCreateOption={ val => {
                                    let temp = [...categories]
                                    temp.push(val)
                                    setCategories(temp)
                                    setCategory({ label: val, value: val })
                                }}
                                onChange={setCategory}
                                options={categories.map(category => ({ label: category, value: category }))}
                                placeholder="Select Category" />
                        </div>
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-quantity">
                                Selling Price
                            </label>
                            <input
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-sp"
                                type="number"
                                name="sp"
                                onChange={modify}
                                value={ sp }
                                placeholder="XXXX" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Received In
                            </label>
                            <Creatable
                                value={receivedIn}
                                onCreateOption={ val => {
                                    let temp = [...units]
                                    temp.push(val)
                                    setUnits(temp)
                                    setReceivedIn({ label: val, value: val })
                                }}
                                onChange={setReceivedIn}
                                options={units.map(unit => ({ label: unit, value: unit }))}
                                placeholder="Search for Unit" />
                        </div>
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Issued In
                            </label>
                            <Creatable
                                value={issuedIn}
                                onCreateOption={ val => {
                                    let temp = [...units]
                                    temp.push(val)
                                    setUnits(temp)
                                    setIssuedIn({ label: val, value: val })
                                }}
                                onChange={setIssuedIn}
                                options={units.map(unit => ({ label: unit, value: unit }))}
                                placeholder="Select for Unit" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-end mt-2">
                <button disabled={ loading } onClick={ () => {
                    editInventoryItem()
                    editSaleItem()
                }} type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
            </div>
        </Modal>
    )
}

export default EditInventoryItem
